import pluralize from "pluralize";

import { getTimezoneAbbreviation } from "./getTimezoneAbbreviation";

/**
 * Formats a timezone with its offset from another timezone.
 * Uses timezone abbreviation for display (e.g., "EST (3 hrs later)")
 * When timezones are the same, only shows the abbreviation (e.g., "EST")
 */
export function formatTimezoneWithOffset(timeZone: string, differenceInHours: number): string {
  const timezoneAbbr = getTimezoneAbbreviation(timeZone);
  if (differenceInHours === 0) {
    return timezoneAbbr;
  }

  const hours = Math.abs(differenceInHours);
  const direction = differenceInHours > 0 ? "later" : "earlier";
  return `${timezoneAbbr} (${hours} ${pluralize("hr", hours)} ${direction})`;
}
